module.exports = __webpack_public_path__ + "media/src/assets/Images/NotificationBlue-72e75e921405450128fb080401650df8.svg";